// removed by extract-text-webpack-plugin
module.exports = {"floatingBottom":"qempo_FloatingBottom_floatingBottom-2i2MjAP"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/FloatingBottom/FloatingBottom.scss
// module id = 1326
// module chunks = 0